import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import {
  Layout,
  Modal,
  Form,
  Input,
  Button
} from 'antd'
import { Container, Row, Col, Card, CardHeader } from 'reactstrap'
import Header from '../Header'
import API from '../../api/index'
class AreaCreate extends Component {
  constructor (props) {
    super(props)
    this.initialState = {
      name: undefined,
      errorName: undefined,
      redirect: undefined
    }
    this.state = this.initialState
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onBack = this.onBack.bind(this)
  }

  updateState (key, value) {
    this.setState({
      [key]: value
    })
  }

  onChange (event) {
    this.updateState(event.target.name, event.target.value)
  }

  async onSubmit () {
    this.clearErrors()
    const response = await API.area.create({
      name: this.state.name
    })
    if (response._id) {
      Modal.success({
        title: 'Creación de una área',
        content: `El área ${this.state.name} fue creado exitosamente`
      })
      this.clearFields()
      this.onBack()
    }
    if (response.errors) {
      this.makeErrors(response.errors)
    }
  }

  makeErrors (error) {
    if (error.name) {
      this.updateState('errorName', error.name.message)
    }
  }

  clearFields () {
    this.updateState('name', undefined)
    this.clearErrors()
  }

  clearErrors () {
    this.updateState('errorName', undefined)
  }

  async onBack () {
    this.updateState('redirect', '/area')
  }

  render () {
    if (this.state.redirect) {
      return (<Redirect to={this.state.redirect} />)
    }
    return (
      <Layout className='layout'>
        <Header item='area' />
        <div className='main-content' ref='mainContent'>
          <Container fluid>
            <Row className='mt-5 mb-5'>
              <Col className='mb-5 mb-xl-0' xl='12'>
                <Card className='shadow content-auto'>
                  <CardHeader className='border-0'>
                    <Row className='align-items-center'>
                      <div className='col'>
                        <h3 className='mb-0'>Nueva área</h3>
                        <h6 className='text-uppercase text-warning ls-1 mb-1'>
                          * Son campos obligatorios
                        </h6>
                      </div>
                      <div className='col text-right'>
                        <Button onClick={this.onBack}>Regresar</Button>
                        {' '}
                        <Button onClick={this.onSubmit}>Guardar</Button>
                      </div>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Item
                          label='Nombre*'
                          validateStatus={this.state.errorName && ('error')}
                          help={this.state.errorName}
                        >
                          <Input
                            type='text'
                            name='name'
                            placeholder='Ingrese el nombre del área'
                            onChange={this.onChange}
                            value={this.state.name}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </CardHeader>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>
    )
  }
}

export default AreaCreate
